import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    spacer: {
        marginBottom: theme.spacing(2),
        height: '1px'
    }
});

const VerticalSpacer = ({ classes }) => <div className={classes.spacer} />;

VerticalSpacer.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired
};

export default withStyles(styles, { withTheme: true })(VerticalSpacer);
